import { ImpostoTypes } from './impostoAction';

export const initialState = {
  carregandoRegistro: false,
  carregandoRegistros: false,
  cadastrar: false,
  visualizar: false,
  registro: {
    id: '',
    nome: '',
    codigo: '',
    aliquota: '',
    tipo: '',
    fornecedor: '',
  },
  page: { number: 0, size: 0, totalElements: 0, sort: 'nome,asc', content: [] },
  selecionados: [],
  tipoSelecao: 'NENHUM', // NENHUM, TODOS_PAGINA, TODOS_FILTRO
  mensagem: undefined,
  requestParams: { page: 0, size: 15, sort: 'nome,asc', q: '' },
};

function impostoReducer(state, action) {
  const { type, payload = {} } = action;

  switch (type) {
    case ImpostoTypes.INITIAL_STATE: {
      return { ...initialState };
    }
    case ImpostoTypes.MENSAGEM: {
      return { ...state, mensagem: payload };
    }
    case ImpostoTypes.BUSCAR_REGISTROS: {
      return { ...state, ...payload };
    }
    case ImpostoTypes.CADASTRAR_REGISTRO: {
      return { ...state, visualizar: false, cadastrar: true, registro: initialState.registro };
    }
    case ImpostoTypes.REMOVER_REGISTROS: {
      return { ...state };
    }
    case ImpostoTypes.VISUALIZAR_REGISTRO: {
      return { ...state, visualizar: true, cadastrar: false, registro: payload };
    }
    case ImpostoTypes.EDITAR_REGISTRO: {
      return { ...state, visualizar: false, cadastrar: true, registro: payload };
    }
    case ImpostoTypes.SELECIONADOS: {
      return { ...state, selecionados: payload };
    }
    case ImpostoTypes.TIPO_SELECAO: {
      return { ...state, tipoSelecao: payload };
    }
    case ImpostoTypes.CARREGANDO_REGISTROS: {
      return { ...state, carregandoRegistros: payload };
    }
    case ImpostoTypes.CARREGANDO_REGISTRO: {
      return { ...state, carregandoRegistro: payload };
    }
    case ImpostoTypes.FECHAR_MODAL_CADASTRO: {
      return { ...state, cadastrar: false, registro: initialState.registro };
    }
    case ImpostoTypes.FECHAR_MODAL_VISUALIZACAO: {
      return { ...state, visualizar: false, registro: initialState.registro };
    }
    case ImpostoTypes.ERRO: {
      return {
        ...state,
        ...payload,
      };
    }
    case ImpostoTypes.SUCESSO: {
      return {
        ...state,
        ...payload,
      };
    }
    case ImpostoTypes.REQUEST_PARAMS: {
      return {
        ...state,
        requestParams: { ...state.requestParams, ...payload },
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export default impostoReducer;
